<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="input-nama">
          Nama Lengkap <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <input
            type="text"
            name="nama"
            value=""
            id="input-nama"
            class="form-control"
            placeholder="Nama Lengkap"
            required
            v-model="nama"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-username">
          Username <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <input
            type="text"
            name="username"
            value=""
            id="input-username"
            class="form-control"
            placeholder="Username"
            required
            v-model="username"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-email">Email</label>
        <div class="form-group">
          <input
            type="email"
            name="email"
            value=""
            id="input-email"
            class="form-control"
            placeholder="Email"
            v-model="email"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-telpon">No. Telpon</label>
        <div class="form-group">
          <input
            type="text"
            name="telpon"
            value=""
            id="input-telpon"
            class="form-control"
            placeholder="No. Telpon"
            v-model="phone"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-role">Role <span class="text-danger">*</span></label>
        <div class="form-group">
          <select
            name="role"
            id="input-role"
            class="form-control"
            required
            v-model="role"
          >
            <option value="2">Admin</option>
            <option value="3">User</option>
            <option value="4">Viewer</option>
          </select>
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
  name: "EditUser",
  props: {
    data: Array,
  },
  data() {
    return {
      nama: this.data[0].nama,
      username: this.data[0].username,
      email: this.data[0].email,
      phone: this.data[0].phone,
      role: this.data[0].role,
      id: this.data[0]._id.$oid,
    };
  },
  methods: {
    submitForm: function () {
      if (
        this.nama != null &&
        this.username != null &&
        this.email != null &&
        this.role != null
      ) {
        let params = {
          _id: this.id,
          nama: this.$sanitize(this.nama),
          username: this.$sanitize(this.username),
          email: this.$sanitize(this.email),
          phone: this.$sanitize(this.phone),
          role: btoa(parseInt(this.role)),
        };
        let api = process.env.VUE_APP_API_URL + "users-update";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.$parent.$parent.getUser();

              $("#modalSlideUp").modal("hide");
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> User berhasil diupdate!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            } else {
              $("#modalSlideUp").modal("hide");
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Terjadi Kesalahan!</b> ' +
                    response.data,
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch((error) => {
            let stts = error.response.data.status;
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message: '<i class="bi bi-x-circle"></i> <b>Error!</b> ' + stts,
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          });
      }
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>